import ProductsContainer from "./components/ProductsList"
import NavbarContainer from "./components/NavbarContainer"
import ShopingCartContextProvider from "./context/ShopingCartContext"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Checkout from "./components/Checkout"
import CountsView from "./components/CountsView"
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.css';
import $ from 'jquery';
import { createPopper } from '@popperjs/core';
import StatsTable from "./components/StatsTable"
import ClosingRecords from './components/ClosingRecords';
import BillingBanner from './components/BillingBanner';



function App() {
  return (
    <div class ="App">
      <ShopingCartContextProvider>
        <BrowserRouter>
            <BillingBanner/>
            <NavbarContainer/>
            <Routes>
                <Route exect path="/" element = {<ProductsContainer/>}/>
                <Route exect path = "/cuentas" element = {<CountsView/>}/>
                <Route exect path="/recibo/:carrito" element = {<Checkout/>}/>
                <Route exect path="/cuentas/:date" element = {<StatsTable/>}/>
                <Route path="/cuentas/closings" element={<ClosingRecords />} />
            </Routes>
        </BrowserRouter>
      </ShopingCartContextProvider>
    </div>
  )
}

export default App
